import React, { HTMLAttributes } from "react";
import cx from "clsx";
import { CommonComponentProps } from "./componentTypes";
import { cleanHtmlRestProps } from "@/lib/utils";

interface StrongTextProps
  extends HTMLAttributes<HTMLParagraphElement>,
    CommonComponentProps {}

export function StrongText({ children, className, ...rest }: StrongTextProps) {
  return (
    <strong
      className={cx("font-bold", className)}
      {...cleanHtmlRestProps(rest)}
    >
      {children}
    </strong>
  );
}
